import styles from './Badge.module.scss';

/**
 * Badge component
 * @param {{
 *   text: string,
 *   className?: string,
 *   icon?: JSX.Element,
 *   variant?: "primary" | "danger" | "success" | "warning" | "info",
 *   outlined?: boolean,
 *   onClick?: () => void
 * }} props
 * @returns {JSX.Element} Badge
 */
function Badge({ text, className, icon, variant = 'primary', outlined = false, onClick }) {
  return (
    <span
      onClick={onClick}
      className={`${styles['badge']} ${styles[`badge--${outlined ? 'outlined' : 'filled'}--${variant}`]} ${className}`}
    >
      {text}
      {icon ? <span className={styles['badge__icon']}>{icon}</span> : null}
    </span>
  );
}

export default Badge;
